import { render, staticRenderFns } from "./permissionsSelect.vue?vue&type=template&id=493d8130"
import script from "./permissionsSelect.vue?vue&type=script&lang=js"
export * from "./permissionsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports